import { Controller } from "@hotwired/stimulus";

import { initTooltips } from "../vendors/tooltip";

import {
  initTomSelect,
  destroyTomSelect,
  refreshTomSelectOptions,
} from "../vendors/tom_select";

export default class extends Controller {
  static targets = ["menu", "container", "form"];

  initialize() {
    this.insertDataIn = undefined;
  }

  connect() {
    this.element
      .querySelectorAll("select")
      .forEach((select) => initTomSelect(select));
    initTooltips("[data-tooltip-content]", {
      placement: "right",
      theme: "blue",
    });

    document.addEventListener("turbo:submit-end", this.handleNewData);
    if (Boolean(this.element.dataset.autoSave)) {
      // this.autoSaveTimer = setInterval(() => {
      //   Rails.fire(this.formTarget, 'submit')
      // }, 10000);
    }
  }

  disconnect() {
    this.element.querySelectorAll("select").forEach(destroyTomSelect);
    document.removeEventListener("turbo:submit-end", this.handleNewData);
    // if (this.autoSaveTimer) {
    //   clearInterval(this.autoSaveTimer)
    // }
  }

  toggleMenu(evt) {
    this.menuTarget.classList.toggle("expended");
    this.containerTarget.classList.toggle("expended");

    this.menuTarget.classList.toggle("narrowed");
    this.containerTarget.classList.toggle("narrowed");

    if (this.menuTarget.classList.contains("narrowed")) {
      document.cookie = "menu=narrowed; path=/";
    } else {
      document.cookie = "menu=expended; path=/";
    }
  }

  newDataClicked(evt) {
    this.insertDataIn = evt.target.closest(".fields").querySelector("select");
  }

  handleNewData = async (e) => {
    if (e.detail.success) {
      const fetchResponse = await e.detail.fetchResponse;
      const response = await fetchResponse.responseHTML;

      const doc = new DOMParser().parseFromString(response, "text/html");
      const selectedId = doc.querySelector(".data-id")?.dataset.id;

      if (e.target.id === "new_address") {
        this.refreshAddresses(selectedId);
      }
      if (e.target.id === "new_customer") {
        this.refreshCustomers(selectedId);
      }
    }
  };

  async refreshCustomers(selectedId) {
    const url = "/customers.json?for_select=true";
    const customers = await (await fetch(url)).json();
    refreshTomSelectOptions(this.insertDataIn, customers, selectedId);
    this.insertDataIn = undefined;
  }

  async refreshAddresses(selectedId) {
    const customerId = this.insertDataIn
      .closest(".customer-fields")
      ?.querySelector(".customer-field")?.value;

    const url = customerId
      ? `/customers/${customerId}/addresses.json`
      : "/addresses.json?for_select=true";

    const addresses = await (await fetch(url)).json();
    refreshTomSelectOptions(this.insertDataIn, addresses, selectedId);
    this.insertDataIn = undefined;
  }
}
